export const cloneDeep = <T>(value: T): T => {
  if ('structuredClone' in window) {
    return structuredClone(value);
  }

  return value === undefined ? undefined : JSON.parse(JSON.stringify(value));
};
